// Presentation only: identifiers and saved answers retain their original meaning.
const opcionesPospuestas = new Set([
  'SED-09.REVISION_POSTERIOR_04', 'VEN-03.LO_DECIDIRE_DESPUES', 'BAN-01.MAS_ADELANTE',
  'PRO-02.COMPLETAR_DESPUES', 'PRO-02.REVISION_POSTERIOR_03',
  'CXC-02.COMPLETAR_DESPUES', 'CXC-02.REVISION_POSTERIOR_03',
  'CXC-06.REVISION_POSTERIOR_04', 'CXC-07.COMPLETAR_DESPUES', 'CXC-07.REVISION_POSTERIOR_04',
]);

export const opcionesVisibles = (elemento, seleccionadas = []) =>
  (elemento.Opciones || []).filter(opcion => !opcionesPospuestas.has(opcion.Codigo) || seleccionadas.includes(opcion.Codigo));

export const nombreRegistro = (elemento, indice) =>
  `${elemento.Codigo === 'BAN-02' ? 'Cuenta bancaria' : elemento.Codigo === 'BAN-04' ? 'Cuenta y formato' : elemento.Codigo === 'SED-04' ? 'Sucursal' : 'Registro'} ${indice + 1}`;

export const pistaCampo = codigo => ({
  'EMP-03.NOMBRE_LEGAL': 'Nombre registrado de la empresa',
  'EMP-03.NOMBRE_COMERCIAL_OPCIONAL': 'Nombre con el que tus clientes conocen el negocio',
  'EMP-06.TELEFONO': '###-###-####',
  'EMP-06.SEGUNDO_TELEFONO_OPCIONAL': '###-###-####',
  'EMP-06.CORREO': 'Ej.: contacto@tuempresa.com o .com.do',
  'SED-04.POR_CADA_SUCURSAL_NOMBRE': 'Ej.: Sucursal Norte',
  'SED-04.DIRECCION': 'Calle, número y referencia',
  'SED-04.TELEFONO': '###-###-####',
  'BAN-02.NOMBRE_CUENTA': 'Ej.: Cuenta de operaciones',
  'VEN-07.PRECIO2_LABEL': 'Ej.: Mayorista',
  'VEN-07.PRECIO3_LABEL': 'Ej.: Cliente preferencial',
})[codigo];
